<template>
  <footer class="lp-v2-footer">
    <div class="lp-v2-container">
      <div class="lp-v2-footer-grid">
        <!-- Logo + tagline -->
        <div class="lp-v2-footer-logo-col">
          <a href="#">
            <img
              v-if="landingPageData.picture_link"
              :src="landingPageData.picture_link"
              :alt="landingPageData.title"
              class="lp-v2-footer-logo"
            />
          </a>
          <p class="lp-v2-footer-tagline">
            {{ landingPageData.description ? landingPageData.description.substring(0, 120) + (landingPageData.description.length > 120 ? '...' : '') : '' }}
          </p>
        </div>

        <!-- Right: details grid -->
        <div class="lp-v2-footer-details">
          <!-- Head Office -->
          <div class="lp-v2-footer-col">
            <h6 class="lp-v2-footer-subtitle">Head Office</h6>
            <p v-if="landingPageData.address" class="lp-v2-footer-text">
              {{ landingPageData.address }}
            </p>
            <!-- Social links -->
            <div v-if="hasSocial" class="lp-v2-footer-social">
              <a v-if="landingPageData.instagram" :href="landingPageData.instagram" target="_blank" aria-label="Instagram">
                <i class="bi bi-instagram" />
              </a>
              <a v-if="landingPageData.tiktok" :href="landingPageData.tiktok" target="_blank" aria-label="TikTok">
                <i class="bi bi-tiktok" />
              </a>
              <a v-if="landingPageData.linkedin" :href="landingPageData.linkedin" target="_blank" aria-label="LinkedIn">
                <i class="bi bi-linkedin" />
              </a>
              <a v-if="landingPageData.youtube" :href="landingPageData.youtube" target="_blank" aria-label="YouTube">
                <i class="bi bi-youtube" />
              </a>
              <a v-if="landingPageData.facebook" :href="landingPageData.facebook" target="_blank" aria-label="Facebook">
                <i class="bi bi-facebook" />
              </a>
            </div>
          </div>

          <!-- Contact Us -->
          <div class="lp-v2-footer-col">
            <h6 class="lp-v2-footer-subtitle">Contact Us</h6>
            <div v-if="landingPageData.email" class="lp-v2-footer-contact-item">
              <i class="bi bi-envelope" />
              <span>{{ landingPageData.email }}</span>
            </div>
            <div v-if="landingPageData.phone" class="lp-v2-footer-contact-item">
              <i class="bi bi-telephone" />
              <span>{{ landingPageData.phone }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="lp-v2-footer-bottom">
        <p>Copyright &copy; {{ currentYear }} {{ companyName }}. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    landingPageData: { type: Object, required: true },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    companyName() {
      return this.landingPageData.creator?.company?.name ?? ''
    },
    hasSocial() {
      const d = this.landingPageData
      return d.instagram || d.tiktok || d.linkedin || d.youtube || d.facebook
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #1675bc;

.lp-v2-footer {
  background: #07093f;
  color: rgba(255, 255, 255, 0.75);
  padding: 4.5rem 0 0;
}

.lp-v2-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.lp-v2-footer-grid {
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 4rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
}

.lp-v2-footer-logo-col {
  display: flex;
  flex-direction: column;
}

.lp-v2-footer-logo {
  max-height: 56px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  margin-bottom: 1.25rem;
  display: block;
}

.lp-v2-footer-tagline {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.7;
  margin: 0;
  max-width: 300px;
}

.lp-v2-footer-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

.lp-v2-footer-subtitle {
  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 1.1rem;
}

.lp-v2-footer-text {
  font-size: 0.875rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 1rem;
}

.lp-v2-footer-social {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;

  a {
    color: rgba(255, 255, 255, 0.55);
    font-size: 1.1rem;
    transition: color 0.2s;

    &:hover { color: $primary; }
  }
}

.lp-v2-footer-contact-item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-bottom: 0.65rem;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.6);

  i {
    margin-top: 2px;
    color: $primary;
    font-size: 1rem;
    flex-shrink: 0;
  }
}

.lp-v2-footer-bottom {
  padding: 1.4rem 0;
  text-align: center;

  p {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.35);
    margin: 0;
  }
}
</style>
